'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { ActionsLike } from '@s7/icons';
import { Group } from '@s7/layout';
import { Typography } from '@s7/ui';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var HelpCenterItemHint = function(props) {
    var children = props.children, isDesktop = props.isDesktop, others = _object_without_properties_loose(props, [
        "children",
        "isDesktop"
    ]);
    return /*#__PURE__*/ jsxs(Group, _extends({
        align: "center",
        spacing: 8,
        noWrap: true
    }, others, {
        children: [
            /*#__PURE__*/ jsx(Typography, {
                color: "text.tertiary",
                size: isDesktop ? "sm1" : "xs2",
                children: children
            }),
            /*#__PURE__*/ jsx(ActionsLike, {
                color: "text.quaternary",
                size: isDesktop ? "1rem" : "0.75rem",
                sx: {
                    display: "flex"
                }
            })
        ]
    }));
};

export { HelpCenterItemHint };
